import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ModulosSelecaoService } from 'src/app/filtro-lateral/service/modulos/modulos-selecao-id/modulos-selecao-id.service';
import { FiltroResponsavelComponent } from 'src/app/metricas/components/filtros-metricas/filtro-responsavel/filtro-responsavel.component';
import { FiltroTipoObraComponent } from 'src/app/metricas/components/filtros-metricas/filtro-tipo-obra/filtro-tipo-obra.component';
import { BntImprimirComponent } from 'src/app/shared/components/buttons/bnt-imprimir/bnt-imprimir.component';
import { BtnExportarExcelComponent } from 'src/app/shared/components/buttons/btn-exportar-excel/btn-exportar-excel.component';
import { BtnExportarPdfComponent } from 'src/app/shared/components/buttons/btn-exportar-pdf/btn-exportar-pdf.component';
import { getRotaPorModuleId } from 'src/app/shared/components/filtros-busca/service/modulos-service/modulos.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { ColumnConfig, DEFAULT_COLUMNS } from './interface/columns.interface';
import {
  DEFAULT_TIPOS_OBRA,
  TipoObra,
} from './interface/tipos-obras.interface';

@Component({
  selector: 'app-listagem-obras',
  standalone: true,
  templateUrl: './listagem-obras.component.html',
  styleUrls: ['./listagem-obras.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    FiltroTipoObraComponent,
    FiltroResponsavelComponent,
    BtnExportarExcelComponent,
    BtnExportarExcelComponent,
    BntImprimirComponent,
    BtnExportarPdfComponent,
  ],
})
export class ListagemObrasComponent implements OnInit {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  tiposObra: TipoObra[] = DEFAULT_TIPOS_OBRA;
  filtroTipoObraSelecionados: number[] = [];
  userId: string;

  colunaOrdenada = '';
  direcaoOrdenacao: 'asc' | 'desc' = 'asc';
  responsavelSelecionado: number = 0;
  filtroResponsavel: string = 'Todos';

  @Input() mostrarApenasItensPagina = false;
  @Input() exibirCabecalho = true;
  @Input() mostrarTagsTipoObra = false;
  @Input() isResultadoFiltro: boolean = false;
  @Input() exibirFiltros = true;

  @Input() selectedRows: any[] = [];
  @Input() loading = false;
  @Input() title = '';
  @Input() subtitle = '';
  @Input() descriptionSubtitle = '';
  @Input() data: any[] = [];
  @Input() columns: ColumnConfig[] = DEFAULT_COLUMNS;
  @Input() pageSizeOptions: number[] = [25, 50, 100];
  @Input() pageSize = 50;
  @Input() page = 1;
  @Input() totalItems = 0;
  @Input() showFiltroResponsavel = false;
  @Input() temAcessoModulo: boolean = true;
  @Input() podeEditarAcao: boolean = false; // Permite ações mesmo sem acesso direto ao módulo quando em edição de busca salva
  @Input() searchType: string = '';
  @Input() searchTerm: string = '';
  @Input() updateInterval: number | null = null;

  @Output() responsavelIdChange = new EventEmitter<number>();
  @Output() responsavelLimpo = new EventEmitter<void>();
  @Output() abrirEmpresa = new EventEmitter<any>();
  @Output() abrirFichaObra = new EventEmitter<any>();
  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() selectionChange = new EventEmitter<any[]>();
  @Output() tiposSelecionadosChange = new EventEmitter<number[]>();
  @Input() responsavel: any[] = [];
  @Output() downloadPdf = new EventEmitter<void>();
  @Output() imprimir = new EventEmitter<void>();
  @Output() excel = new EventEmitter<void>();
  @Output() sortChange = new EventEmitter<{
    column: string;
    direction: 'asc' | 'desc';
  }>();
  @Output() searchTypeChange = new EventEmitter<string>();
  @Output() searchTermChange = new EventEmitter<string>();
  @Output() searchEnter = new EventEmitter<void>();
  @Output() updateIntervalChange = new EventEmitter<number | null>();

  private modulosSelecaoService: ModulosSelecaoService;

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {
    this.userId = this.authService.userID;
  }

  ngOnInit(): void {}

  selectAllChecked: boolean = false;
  limparSelecao() {
    this.selectedRows = [];
    this.selectAllChecked = false;
  }
  getFirstItemIndex(): number {
    return this.totalItems === 0 ? 0 : (this.page - 1) * this.pageSize + 1;
  }

  getLastItemIndex(): number {
    return Math.min(this.page * this.pageSize, this.totalItems);
  }

  getTotalPages(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }

  min(a: number, b: number): number {
    return Math.min(a, b);
  }

  toggleSelectAll(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.selectAllChecked = isChecked;
    this.selectedRows = isChecked ? [...this.data] : [];
    this.selectionChange.emit(this.selectedRows);
  }

  toggleRow(row: any, checked: boolean) {
    if (checked) {
      this.selectedRows.push(row);
    } else {
      this.selectedRows = this.selectedRows.filter((r) => r !== row);
    }
    this.selectionChange.emit(this.selectedRows);
  }

  onObraClick(obra: any) {
    this.abrirFichaObra.emit(obra);
  }

  getChecked(event: Event): boolean {
    return (event.target as HTMLInputElement).checked;
  }

  ordenarPor(coluna: string) {
    if (this.colunaOrdenada === coluna) {
      this.direcaoOrdenacao = this.direcaoOrdenacao === 'asc' ? 'desc' : 'asc';
    } else {
      this.colunaOrdenada = coluna;
      this.direcaoOrdenacao = 'asc';
    }
    this.sortChange.emit({ column: coluna, direction: this.direcaoOrdenacao });
  }

  mudarPagina(direcao: number) {
    const novaPagina = this.page + direcao;
    const totalPages = Math.ceil(this.totalItems / this.pageSize);
    if (novaPagina >= 1 && novaPagina <= totalPages) {
      this.pageChange.emit(novaPagina);

      setTimeout(() => {
        const el = document.querySelector('.listagem-obras');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 0);
    }
  }

  get visiblePages(): number[] {
    const maxVisible = 10;
    const totalPages = Math.ceil(this.totalItems / this.pageSize);
    const pages: number[] = [];
    let start = Math.max(1, this.page - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }

  goToPage(p: number) {
    if (p !== this.page) {
      this.pageChange.emit(p);
      setTimeout(() => {
        const el = document.querySelector('.listagem-obras');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 0);
    }
  }

  onTiposObraSelecionadosChange(tipos: number[]) {
    this.filtroTipoObraSelecionados = tipos;
    this.tiposSelecionadosChange.emit(tipos);
  }

  onFiltroResponsavelChange(responsavel: string) {
    this.filtroResponsavel = responsavel;
  }

  onDownloadPdf() {
    this.downloadPdf.emit();
    this.limparSelecao();
  }

  onImprimir() {
    this.imprimir.emit();
    this.limparSelecao();
  }

  onExportarExcel() {
    this.excel.emit();
    this.limparSelecao();
  }

  getTagClass(val: string): string {
    if (!val) return '';
    return val
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/\s/g, '');
  }

  tipoObraColors: { [key: string]: string } = {
    'edifícios residenciais': '#495057',
    indústrias: '#b4ada1',
    'centro de saúde': '#009688',
    'pavimentação urbana': '#6b6864',
    comercial: '#eb5e28',
    residencial: '#eb5e28',
    industrial: '#b4ada1',
    infraestrutura: '#6b6864',
  };

  getTipoObraColor(tipo: string): string {
    if (!tipo) return '#888';
    const key = tipo.trim().toLowerCase();
    return this.tipoObraColors[key] || '#888';
  }

  onEmpresaClick(row: any) {
    const empresaId = row.companyID ?? row.CompanyID ?? null;
    const moduloId = Number(row.moduleId ?? row.moduleID ?? 0);

    if (empresaId && moduloId) {
      const rota = getRotaPorModuleId(moduloId);
      this.router.navigate(['/empresas/detalhes', rota, empresaId]);
      return;
    }

    const termo = row.companyName || row.empresa || row.name || '';
    this.router.navigate(['/empresas'], { queryParams: { termo } });
  }

  onResponsavelIdChange(id: any) {
    let idNum = typeof id === 'number' ? id : Number(id);
    if (isNaN(idNum)) idNum = 0;
    this.responsavelSelecionado = idNum;
    this.responsavelIdChange.emit(idNum);
  }

  onResponsavelLimpo() {
    this.responsavelSelecionado = 0;
    this.responsavelLimpo.emit();
  }

  onSearchTypeChange(value: string) {
    this.searchType = value;
    this.searchTypeChange.emit(value);
  }

  onSearchTermChange(value: string) {
    this.searchTerm = value;
    this.searchTermChange.emit(value);
  }

  onSearchEnter() {
    this.searchTermChange.emit(this.searchTerm);
    this.searchEnter.emit();
  }

  onUpdateIntervalChange(value: number | null) {
    if (this.updateInterval === value) {
      this.updateInterval = null;
    } else {
      this.updateInterval = value;
    }
    this.updateIntervalChange.emit(this.updateInterval);
  }

  clearSearch() {
    this.searchTerm = '';
    this.searchTermChange.emit('');
    this.searchEnter.emit();
  }
}
